import { CATEGORY_ITEMS } from './CONSTANTS';
import { pluralText } from './wordUtilities';

const isPage = item => item.type === CATEGORY_ITEMS.PAGE;
const isFolder = item => item.type === CATEGORY_ITEMS.FOLDER || item.type === CATEGORY_ITEMS.SUBCATEGORY;
const isSuggestion = item => item.type === CATEGORY_ITEMS.SUGGESTION;
const isExternal = item => item.type === CATEGORY_ITEMS.EXTERNAL;
const isQuestion = item => item.type === CATEGORY_ITEMS.QUESTION;
const isDocument = item => item.type === CATEGORY_ITEMS.DOCUMENT;
const isSubcategory = item => item.type === CATEGORY_ITEMS.FOLDER || item.type === CATEGORY_ITEMS.SUBCATEGORY;

const addIdToArray = (id, array) => {
    if (!array.includes(id)) {
        array.push(id);
    }
    return array;
};

const removeIdFromArray = (id, array) => array.filter(arrayId => (arrayId !== id));

const getArchivedText = (pagesCount, foldersCount, suggestionsCount, externalResourcesCount, questionsCount, documentsCount) => {
    const itemsCount = pagesCount + suggestionsCount + externalResourcesCount + questionsCount + documentsCount;
    let archivedText = itemsCount && foldersCount
        ? `Archived ${pluralText(itemsCount, 'item')} and deleted ${pluralText(foldersCount, 'subcategory')}`
        : null;
    if (!archivedText) {
        archivedText = itemsCount
            ? `Archived ${pluralText(itemsCount, 'item')}`
            : `deleted ${pluralText(foldersCount, 'subcategory')}`;
    }
    return archivedText;
};

const getMovedText = (pagesCount, foldersCount, suggestionsCount, externalResourcesCount, questionsCount, documentsCount) => {
    const itemsCount = pagesCount + suggestionsCount + externalResourcesCount + questionsCount + documentsCount;
    let movedText = itemsCount && foldersCount
        ? `Moved ${pluralText(itemsCount, 'item')} and ${pluralText(foldersCount, 'subcategory')}`
        : null;
    if (!movedText) {
        movedText = itemsCount
            ? `Moved ${pluralText(itemsCount, 'item')}`
            : `Moved ${pluralText(foldersCount, 'subcategory')}`;
    }
    return movedText;
};

const getTotalPageCount = (pinnables) => pinnables.reduce((sum, item) => (isPage(item) ? sum + 1 : sum), 0);
const getTotalFolderCount = (pinnables) => pinnables.reduce((sum, item) => (isFolder(item) ? sum + 1 : sum), 0);
const getTotalSuggestionCount = (pinnables) => pinnables.reduce((sum, item) => (isSuggestion(item) ? sum + 1 : sum), 0);
const getTotalExternalResourceCount = (pinnables) => pinnables.reduce((sum, item) => (isExternal(item) ? sum + 1 : sum), 0);
const getTotalQuestionCount = (pinnables) => pinnables.reduce((sum, item) => (isQuestion(item) ? sum + 1 : sum), 0);
const getTotalDocumentCount = (pinnables) => pinnables.reduce((sum, item) => (isDocument(item) ? sum + 1 : sum), 0);

export {
    isPage,
    isFolder,
    isSuggestion,
    isExternal,
    isQuestion,
    isDocument,
    isSubcategory,
    getArchivedText,
    getMovedText,
    getTotalPageCount,
    getTotalFolderCount,
    getTotalSuggestionCount,
    getTotalExternalResourceCount,
    getTotalQuestionCount,
    getTotalDocumentCount,
    addIdToArray,
    removeIdFromArray,
};
